import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectGlobalOBNDBNBizsListItems } from "../../../../../../redux/obn-dbn-bizs/selector";
import { globalOBNDBNBizs } from "../../../../../../redux/obn-dbn-bizs/action";
import PageLoader from "../../../../../../components/PageLoader";
import EditableTable from "../../../../../../common/components/table-manager/editable-table";
import { deepCopy } from "../../../../../../common/services/common.service";
import Table from "../../../../../../common/components/table";


const OBNDBNBIZRegistries = ({selectedDbnpRegistry}: any) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const globalOBNDBNBizsListItems = useSelector(selectGlobalOBNDBNBizsListItems)
  const [columnDefs, setColumnDefs] = useState({});

    const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
     
      { field: 'Delivery_preference', headerName: 'Delivery Preference' },
      { field: 'MappedBizNetTypes', headerName: 'Biz Net Type', valueFormatter: getTypeName, filterType: 'text' },
      { field: 'CurrentlyServicing', headerName: 'Currently Servicing', cellRenderer: 'yesNoRenderer' },
      { field: 'IsAcceptOrderByDefaultEnabled', headerName: 'Accept Order By DefaultEnabled', cellRenderer: 'yesNoRenderer' },
      { field: 'IsDirectShipmentEnabled', headerName: 'Direct Shipment Enabled', cellRenderer: 'yesNoRenderer' },
      { field: 'UkId', headerName: 'UkId' },
      { field: 'UseSettingsFromConfigFile', headerName: 'Use Settings From ConfigFile', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
      { field: 'IsPublished', headerName: 'IsPublished', cellRenderer: 'yesNoRenderer' },

    ]);
  }
 
  const getTypeName = (data: any) => {
    if (Array.isArray(data)) {
    return data
      .filter(Boolean)
      .map((item: any) => item?.Name)
      .join(', '); // Display as comma-separated list (e.g., "BuyerFacilitator, Seller")
  }
    return data ?? '';
  };
    const fetchOBNDBNBizsList = async () => {
        await dispatch(globalOBNDBNBizs.resetAction({ actionType: 'list' }))
        await dispatch(globalOBNDBNBizs.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/obn-bizs/fetch`,
            entity: 'globalOBNDBNBizs',
            jsonData: {
                "Context": {},
                "Records": [
                    {
                        "OBNRegistryId": selectedDbnpRegistry?.Id
                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "OBNDBNBizId",
                    "SortOrder": "desc"
                }
            }
        }))
    }

    useEffect(() => {
        fetchOBNDBNBizsList();
        createColumnDefs()
    }, [pageData, pageSize])

    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add OBN Biz</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAdd(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const handleAdd = () => {
        navigate(`/dbn/open-network-registrations/${selectedDbnpRegistry?.Id}/obn-biz/${0}`)
    }

    const handleEdit = (data: any) => {
        navigate(`/dbn/open-network-registrations/${selectedDbnpRegistry?.Id}/obn-biz/${data?.OBNBizId}`)
    }

    const handleReloadData = () => {
        fetchOBNDBNBizsList();
    }

    const handleDelete = async (data: any) => {
        await dispatch(globalOBNDBNBizs.resetAction({ actionType: 'delete' }))
        await dispatch(globalOBNDBNBizs.delete({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/obn-bizs/delete`,
            entity: 'globalOBNDBNBizs',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.OBNBizId
                    }
                ]
            }
        })).then(() => {
            fetchOBNDBNBizsList();
        });
    }

    const handleSearch = async (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        await dispatch(globalOBNDBNBizs.resetAction({ actionType: 'list' }))
        await dispatch(globalOBNDBNBizs.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/obn-bizs/fetch`,
            entity: 'globalOBNDBNBizs',
            jsonData: {
                "Context": {},
                "Records": [
                    {
                        "OBNRegistryId": selectedDbnpRegistry?.Id
                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "OBNDBNBizId",
                    "SortOrder": "desc",
                    "Searches": searchCriteria,
                }
            }
        }))
    }


const handleParticularOrgRegistry = async (data: any) => {
    await dispatch(globalOBNDBNBizs.resetAction({ actionType: 'create' }))
    await dispatch(globalOBNDBNBizs.create({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/obn-bizs/publish-obn-biz`,
      entity: 'globalOBNDBNBizs',
      jsonData: {
        Context: {},
        Records: [{
          OBNBizId: data?.OBNBizId
        }]
      }
    })).then(() => {
       dispatch(globalOBNDBNBizs.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/obn-bizs/fetch`,
            entity: 'globalOBNDBNBizs',
            jsonData: {
                "Context": {},
                "Records": [
                    {
                        "OBNRegistryId": selectedDbnpRegistry?.Id
                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "OBNDBNBizId",
                    "SortOrder": "desc",
                }
            }
        }))
    });
  }
    return (
        <div className="h-screen bg-gray-100 flex flex-col">
            {globalOBNDBNBizsListItems?.isLoading ? (
                <PageLoader />
            ) : (
                <div className="p-4">
                    <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
                        <Table
                            columnData={columnDefs}
                            rowData={globalOBNDBNBizsListItems?.result?.items}
                            setPageData={setPageData}
                            setPageSize={setPageSize}
                            paginationData={globalOBNDBNBizsListItems?.result?.pagination}
                            enableFilter={true}
                            onSearch={handleSearch}
                            showBulkupdate={false}
                            isEditable={false}
                            handleParticularOrgRegistry={handleParticularOrgRegistry}IsPublishParticularVendorToCloud={true}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                            additionButtons={additionButtons}
                            headingName="OBN Bizs"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default OBNDBNBIZRegistries;


